import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const StyledStandardSingleFacetLabel = styled("span")<{$isDisabled?: boolean}>`
    ${({theme, $isDisabled}) => $isDisabled && `color: ${theme.colours.text.disabled}`};
    margin-right: 0.3rem;
    white-space: nowrap;
    max-width: 7.5rem;
    overflow: hidden;
    font-family: ${({theme}) => theme.colours.typography.body2.fontFamily};
    @media (min-width: ${breakpoints.values.xl}px) {
        max-width: 10rem;
    }
`
